/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable prefer-const */
'use client';

import {
  checkTokenExpired,
  formatDateStringToLocalVN,
  mapModifiers,
} from '@/utils/funtion';
import { useRouter, useSearchParams } from 'next/navigation';
import { useLayoutEffect, useEffect, useState, Suspense, useMemo } from 'react';
import { getIndicatorDetail } from '@/services/apis/modules/indicator-detail';
import { ResponseDetail, ResponseDetails } from '@/interfaces/indicator-detail';
import Skeleton from '@/components/atoms/skeletons';
import dynamic from 'next/dynamic';
import RichTextEditor from '@/components/molecules/richEditor';
import LazyComponent from '@/components/molecules/lazyComponent';
import React from 'react';
import imgColumn from '@/assets/chart/colum.png';
import imgArea from '@/assets/chart/area.png';
import imgStack from '@/assets/chart/stack-value.png';
import imgStackPercent from '@/assets/chart/stack_percent.png';
import imgBar from '@/assets/chart/colum-vertical.png';
import imgLine from '@/assets/chart/line.png';
import imgColumnLine from '@/assets/chart/column-line.png';
import imgValue from '@/assets/chart/column-value.png';
import imgGroupColumn from '@/assets/chart/group-column.png';
import imgMaps from '@/assets/chart/maps.png';
import imgPie from '@/assets/chart/pie.png';
import Image from 'next/image';
import Empty from '@/components/atoms/empty';
import MapsPackage, { AreaVariant } from '@/components/templates/mapsPackage';
import { useDispatch, useSelector } from 'react-redux';
import ChartPackageSkeleton from '@/components/molecules/skeleton-component/chartPacakge';
import { setDetailUrl } from '@/stores/modules/detailUrl';

const ChartPackage = dynamic(
  () => import('@/components/templates/chartPackage'),
  {
    ssr: false,
    loading: () => {
      return <ChartPackageSkeleton />;
    },
  },
);

function SkeletonView(rows: number = 12) {
  return (
    <div
      className="c-home-loading-skeleton"
      style={{ height: 'fit-content', width: '100%', maxWidth: 1380 }}
    >
      <Skeleton active type="default" loading paragraph={{ rows: rows }} />
    </div>
  );
}

const chartImage: Record<string, any> = {
  column: imgColumn,
  bar: imgBar,
  line: imgLine,
  stack_value: imgValue,
  stack_percent: imgStackPercent,
  object: imgStack,
  column_line: imgColumnLine,
  area: imgArea,
  pie: imgPie,
  group_column: imgGroupColumn,
  maps: imgMaps,
};

const headingTemplate: Record<string, string> = {
  related: 'Dữ liệu liên quan',
  popuplarSearch: 'Dữ liệu phổ biến',
  keySearchData: 'Dữ liệu thịnh hành',
};

const typeData: Record<string, string> = {
  indicator: 'Dữ liệu kinh tế',
  industry_indicator: 'Dữ liệu ngành',
  local_indicator: 'Dữ liệu địa phương',
};
interface IndicatorDetailProps {
  dataDetail: ResponseDetail;
  isStructure: number;
  area?: string;
}
const IndicatorDetailModule: React.FC<IndicatorDetailProps> = ({
  dataDetail,
  isStructure,
  area,
}) => {
  const searchParams = useSearchParams();
  const [response, setResponse] = useState<ResponseDetails>();
  const [selectedTime, setSelectedTime] = useState<string | undefined>(
    undefined,
  );
  const dispatch = useDispatch();
  const router = useRouter();
  const userData = useSelector((state: any) => state.userData);
  useEffect(() => {
    const body = {
      id: response?.detail?.id,
      type: 'local_indicator',
      isStructure: response?.detail?.isStructure ? 1 : 0,
      timeYear: selectedTime,
    };
    if (response?.detail?.chartType === 'maps') handleGetDataById(body);
  }, [selectedTime]);

  useEffect(() => {
    if (
      userData?.refresh_token_exp &&
      checkTokenExpired(userData?.refresh_token_exp)
    ) {
      router.push('/xac-thuc-nguoi-dung?expired=true');
    }
  }, [userData?.refresh_token_exp]);

  const handleSelectTime = (value: string) => {
    setSelectedTime(value);
  };

  const handleFormatData = (data: Record<string, any>): any => {
    if (!data) return [];
    const arr: any[] = [];
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const item = {
          heading: headingTemplate[key],
          key: key,
          data: data[key],
        };
        arr.push(item);
      }
    }
    return arr;
  };

  async function handleGetDataById(body: Record<string, any>) {
    const resp = await getIndicatorDetail(body);
    if (resp) {
      const { detail, status, ...prev } = resp.data as ResponseDetail;
      let data = handleFormatData(prev);
      if (!data) data = [];
      const newDetail = {
        detail,
        data: data,
      };
      setResponse(newDetail);
    }
  }

  useEffect(() => {
    if (!dataDetail) return;
    const { detail, status, ...prev } = dataDetail as ResponseDetail;
    let data = handleFormatData(prev);
    if (!data) data = [];
    const newDetail = {
      detail,
      data: data,
    };
    setResponse(newDetail);
  }, [dataDetail]);

  const renderTab = useMemo(
    () =>
      response?.data.map((tab) => {
        return (
          <React.Fragment key={tab?.key}>
            <LazyComponent>
              <Suspense fallback={SkeletonView(16)}>
                <div className={mapModifiers('p-indicator_detail_tab')}>
                  <h2>{tab?.heading}</h2>
                  {!tab?.data?.length ? (
                    <>
                      <br />
                      <Empty />
                    </>
                  ) : (
                    <ul>
                      {tab?.data?.map((item) => {
                        const newChartType = item?.chart_type;

                        const queryParams = new URLSearchParams({
                          type: searchParams?.get('type') as string,
                          structure: item?.is_structure.toString(),
                          ...(item?.is_object_one_time && {
                            isObjectOneTime:
                              item?.is_object_one_time.toString(),
                          }),
                        });

                        return (
                          <a
                            key={item?.id}
                            className={mapModifiers('p-indicator_detail_item')}
                            href={`/thong-tin-chi-tiet/${item?.slug}/${item?.id}?${queryParams.toString()}`}
                          >
                            <article>
                              <Image
                                src={
                                  chartImage[
                                    newChartType?.replaceAll('-', '_') ||
                                      'column'
                                  ]
                                }
                                alt={item?.chart_type}
                                width={100}
                                height={80}
                                loading="lazy"
                              />
                            </article>
                            <article>
                              <div className={'p-indicator_detail_item_type'}>
                                <p>{typeData[response?.detail?.table]}</p>
                                <span>
                                  {formatDateStringToLocalVN(
                                    item?.updated_at,
                                    'DD-MM-YYYY',
                                  )}
                                </span>
                              </div>
                              <div
                                className={mapModifiers(
                                  'p-indicator_detail_item_header',
                                )}
                              >
                                <h3>{item?.name}</h3>
                              </div>
                              <div
                                className={mapModifiers(
                                  'p-indicator_detail_item_summary',
                                )}
                              >
                                <RichTextEditor
                                  data={item?.summary as string}
                                  isDisabled
                                  isUseHeader={false}
                                  type="transparent"
                                />
                              </div>
                            </article>
                          </a>
                        );
                      })}
                    </ul>
                  )}
                </div>
              </Suspense>
            </LazyComponent>
          </React.Fragment>
        );
      }),
    [response],
  );

  return (
    <React.Fragment>
      <div className={mapModifiers('p-indicator_detail_chart')}>
        <Suspense fallback={SkeletonView()}>
          {response?.detail?.chartType === 'maps' ? (
            <MapsPackage
              id={response?.detail?.id}
              area={(area as AreaVariant) ?? 'VN'}
              dataMaps={response?.detail?.children}
              original={response?.detail?.original}
              originalUrl={response?.detail?.originalUrl}
              unit={response?.detail?.unit}
              mapTitle={response?.detail?.name}
              timeData={response?.detail?.yearList}
              onSelectTime={handleSelectTime}
              chartType={response?.detail?.chartType}
            />
          ) : (
            <ChartPackage
              data={
                !response?.detail?.isStructure &&
                !response?.detail?.isObjectOneTime &&
                !response?.detail?.isTwoUnit
                  ? response?.detail?.value
                  : !response?.detail?.isStructure
                    ? response?.detail?.children.length
                      ? response?.detail?.children
                      : response?.detail?.value
                    : response?.detail?.children
              }
              handleClickRangeTime={(data) => {
                const type = searchParams?.get('type');
                const body = { ...data, type, isStructure: isStructure };
                handleGetDataById(body);
              }}
              name={response?.detail?.name as string}
              original={response?.detail?.original as string}
              unit={response?.detail?.unit as string}
              isTwoUnit={response?.detail?.isTwoUnit}
              isStructure={response?.detail?.isStructure}
              originalUrl={response?.detail?.originalUrl as string}
              id={response?.detail?.id as string}
              isObjectOneTime={response?.detail?.isObjectOneTime}
              dataType={response?.detail?.dataType as string}
              chartType={response?.detail?.chartType as string}
              loading={false}
              typeData={response?.detail?.type as string}
              parentId={response?.detail?.parentId as string}
              isPageDetail
            />
          )}
        </Suspense>
        {!!response?.detail?.note?.trim() && (
          <div className={mapModifiers('p-indicator_detail_chart_note')}>
            <RichTextEditor
              data={
                `<strong>Ghi chú: </strong>${response?.detail?.note}`
                  .replaceAll('<p>', '<span>')
                  .replaceAll('</p>', '</span>') as string
              }
              isDisabled
              isUseHeader={false}
              type="transparent"
            />
          </div>
        )}
      </div>
      {renderTab}
    </React.Fragment>
  );
};

export default IndicatorDetailModule;
